import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';

import { Observable, Subject, Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, map } from 'rxjs/operators';

import { BatchService } from '../../../../services/batch.services';
import { GlobalCfgService } from 'src/services/globalcfg.service';

@Component({
  selector: 'rm-search-auto-complete',
  templateUrl: './search-auto-complete.component.html',
  styleUrls: ['./search-auto-complete.component.css']
})
export class SearchAutoCompleteComponent implements OnInit, OnChanges {

  @Output() packageIdSelectUpdate = new EventEmitter();
  myControl = new FormControl();
  @Input() public placeholderTxt: String = '';
  filteredOptions: any = [];
  filterValues: any[] = [];
  searchTerm$ = new Subject<string>();
  searchSubscription: Subscription;
  packageId: any;
  @Input() private selectedPackageLevel: string = '';
  @Input() private initialPackageList: any[] = [];

  constructor(
    private batchService: BatchService,
    private globalCfgService: GlobalCfgService
  ) { }

  ngOnInit() {
    this.setPackageIdSearchSubscription();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes.initialPackageList) {
      if (
        changes.initialPackageList.currentValue !== undefined &&
        changes.initialPackageList.currentValue.length > 0
      ) {
        this.filteredOptions = changes.initialPackageList.currentValue;
      }
    }
  }

  setPackageIdSearchSubscription() {
    this.searchSubscription = this.packageIdSearch(this.searchTerm$).subscribe(term => {
      this.filter(term);
    });
  }

  packageIdSearch(searchTerms: Observable<string>) {
    return searchTerms.pipe(
      debounceTime(400),
      distinctUntilChanged(),
      map(term => term));
  }

  private filter(val: string) {
    let filterObj = {
      gcp: this.globalCfgService.getGcp(),
      packageLevel: this.selectedPackageLevel,
      searchTxt: val
    };
    
    // call the service which makes the http-request
    this.batchService.searchPackageIds(filterObj).subscribe(
      (value: any) => {
        console.log(value);
        this.filteredOptions = value.result;
      }
    );
  }

  updateMySelection(event) {
    console.log(event);
    this.packageId = event.option.value;
    this.packageIdSelectUpdate.emit(this.packageId)
  }
}